import { z } from 'zod';

/**
 * Common Validation Schemas
 */

export const emailSchema = z.string().min(1, 'Email is required').email('Invalid email address');

export const passwordSchema = z
    .string()
    .min(8, 'Password must be at least 8 characters')
    .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
    .regex(/[0-9]/, 'Password must contain at least one number');

export const requiredStringSchema = (fieldName: string) =>
    z.string().min(1, `${fieldName} is required`).trim();

export const optionalStringSchema = z.string().optional().or(z.literal(''));

export const requiredNumberSchema = (fieldName: string) =>
    z.number({ required_error: `${fieldName} is required` });

export const positiveNumberSchema = (fieldName: string) =>
    z.number({ required_error: `${fieldName} is required` }).positive(`${fieldName} must be positive`);

export const urlSchema = z.string().url('Invalid URL format');

export const phoneSchema = z
    .string()
    .min(1, 'Mobile number is required')
    .regex(/^\d+$/, 'Phone number must contain digits only')
    .min(10, 'Phone number must be at least 10 digits');

export const dateSchema = z.date({
    required_error: 'Date is required',
    invalid_type_error: 'Invalid date format',
});

export const futureDateSchema = z.date().refine(date => date > new Date(), 'Date must be in the future');

export const pastDateSchema = z.date().refine(date => date < new Date(), 'Date must be in the past');


